import { $, $$ } from 'utils/dom';
import Slider from 'modules/Slider/Slider';

const banners = $$('.o-banner--slider');
banners.length &&
  banners.forEach(bannerItem => {
    const items = $('.o-banner__items', bannerItem);

    const Carousel = new Slider(items, {
      config: {
        cellAlign: 'center',
        pageDots: true,
        prevNextButtons: false,
        contain: false,
      },
      conditions: [
        {
          breakpoint: 'more 1200',
          gap: '50px',
        },
        {
          breakpoint: 'less-equal 1199',
          gap: '35px',
        },
      ],
    });
    Carousel.init();
  });
